<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
          {

        "num_cand": "U2FsdGVkX19qCjEAzfHun+g1RrOBqIlMz0wky7t4EVU=",
        "cpf": "U2FsdGVkX1/RFs7L/FFClej0zcS8HoiLj6IYpTzkO+E="
      }, {
        "num_cand": "U2FsdGVkX1/Voa0kcZHGuy9aW/NuOs4caW8JpQwlTvU=",
        "cpf": "U2FsdGVkX1+pZmeJwZQ5bxjNymYKGRzO62T039DZnnk="
      }, {
        "num_cand": "U2FsdGVkX1+qcol8/kNv7xr8I4Qm/5CRUZge16mxga0=",
        "cpf": "U2FsdGVkX19gQUz5AdegT2Fd3WRSIXhSS6G8a1qmkCQ="
      }, {
        "num_cand": "U2FsdGVkX1/GlPUNEPppghuvnxrgi4AtosXxq5GyV/Q=",
        "cpf": "U2FsdGVkX1/jL/L7/Q2SMQXB3TpH142OWSXsgEPwrHY="
      }, {
        "num_cand": "U2FsdGVkX1/c63oBh7xWj1uQVszi2qz1YfYZvFt5NtA=",
        "cpf": "U2FsdGVkX1+TJCPVUvYVcICWKAgp50sa8gofajSee54="
      }, {
        "num_cand": "U2FsdGVkX1+pMtDSBhjw1dAOfZRR1q/dj1pya4yaNWQ=",
        "cpf": "U2FsdGVkX19PmzxCYM7qbguK7WfV9+Mrz1uG2g+Dj+w="
      }, {
        "num_cand": "U2FsdGVkX18AaJRaJQVPUgoqcrrvRo2CL9LLLBeBzEg=",
        "cpf": "U2FsdGVkX1/h4MTdHeJRm1lrSmp/G3dVmgd+Le0ir2k="
      }, {
        "num_cand": "U2FsdGVkX1/JBFukO/E2XH9eTls59OMc8W6z3hhms3g=",
        "cpf": "U2FsdGVkX18Bg7Ws6loYkDw72x3Az73a/2zaW9vZnKM="
      }, {
        "num_cand": "U2FsdGVkX19x4fV6VMXC/lTjWknr3Z5I4lL/m5zauqE=",
        "cpf": "U2FsdGVkX1/hhSzqlWytUpjcmuj5Q7PY9jDbpKh9c0w="
      }, {
        "num_cand": "U2FsdGVkX18m5B1jiMVdkLltYXtCULqcYRS3T0fBb6U=",
        "cpf": "U2FsdGVkX18d1fE8Esb8aDI3hHxeChlJjHeA/u4O2/g="
      }, {
        "num_cand": "U2FsdGVkX1/R9p+vICPSbmL8opvMWzwoop/J8Ca0aso=",
        "cpf": "U2FsdGVkX18zsN4i6VwLm36S2FjKdfnsO0AZhVJEZMo="
      }, {
        "num_cand": "U2FsdGVkX19ibp4swF5ya0jlzVP5u26N+uFPDmpEJ1Y=",
        "cpf": "U2FsdGVkX1/LSrfRxHL3oeM0DJOs1CDLna7WWhuqVhQ="
      }, {
        "num_cand": "U2FsdGVkX1/fudqkLdIBtkd41fPzz4eHlizzqtt3jqQ=",
        "cpf": "U2FsdGVkX19QERyGSV+1eFoMMB/+8n9u+M5Su20q4BA="
      }, {
        "num_cand": "U2FsdGVkX1/90gbEOAfWdYOvkBK/l+g8f5z23GY3TFA=",
        "cpf": "U2FsdGVkX19zC6h38w9cqBCp/bqciPjM8V8i5vqVLZE="
      }, {
        "num_cand": "U2FsdGVkX1/BiPz/HXMIXpF7jNDE8tv+7BJsPPL5qeU=",
        "cpf": "U2FsdGVkX19UPX9pCYjOMX95lLdE3jIYjX6pNtZDIRM="
      }, {
        "num_cand": "U2FsdGVkX18Esuz7OPzZgODpAA64EdpDut1LzQHdhIE=",
        "cpf": "U2FsdGVkX193EeWDaYWUKohLEnyBqfOLLNTvqomygMQ="
      }, {
        "num_cand": "U2FsdGVkX1+VQdsy5NURrTFG5XCZu60ZGijJJ48azAM=",
        "cpf": "U2FsdGVkX18KHNa5V25aeuryZfD6KxIhXeGh6sarco0="
      }, {
        "num_cand": "U2FsdGVkX1/Vn6dFRoh2m0mDefU6PqTBeoSUGZIBV4I=",
        "cpf": "U2FsdGVkX1/BBqjwjaeDi7q/TDEUV7nSITphtulun7A="
      }, {
        "num_cand": "U2FsdGVkX184z1fK0GB7f4MbvOkVrLTF6EC81R/nEew=",
        "cpf": "U2FsdGVkX1/aeG/o+PT2aTCX647O8lUORMdHWaOM7m4="
      }, {
        "num_cand": "U2FsdGVkX1/TGg/Byg9W0dV0oBgqoFi0kSuttdWRf9U=",
        "cpf": "U2FsdGVkX1+hQhxuyqtKEgfMr0+9aT78nM7jPbeWebk="
      }, {
        "num_cand": "U2FsdGVkX1+ZZbLMCvJUBBm20eet4s1KFAe3E3X0cOo=",
        "cpf": "U2FsdGVkX18FXxhcEyPqB7kPSbvpJeltbPogWhzZPk0="
      }, {
        "num_cand": "U2FsdGVkX18A2UZJtC379YcGUv53OZ4+21BOjP9XXmY=",
        "cpf": "U2FsdGVkX1/Yp0fwubfw964Yo1F8iWh6KGTAVBrMG78="
      }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2205/2205_rec_insc/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
